import { SelectMemberPage } from '@euler/app/flows/common/SelectMemberPage';
import { ReworkRecordPage } from '@euler/app/flows/task/pages/delivery-check/rework-record/ReworkRecordPage';
import { ScreenToParams } from '@euler/functions/spreadScreens';

export const ReworkRecordScreens = {
  _record: ReworkRecordPage,
  _selectMember: SelectMemberPage,
};

export type ReworkRecordNavParams = ScreenToParams<typeof ReworkRecordScreens>;
